// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBar_searchContainer__re3J0","searchBox":"SearchBar_searchBox__ZAAgA"};